export default "__VITE_ASSET__CR43hBZg__"